import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {Roles} from './role-entity';
import {RoleDTO} from './dto/role-dto';
import {   ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { RoleMasterService } from './role-master.service';
import {RolesResponse,AllRolesResponse} from '@gtpl/shared-models/masters';
import { RolesRequest } from './dto/role-request';

@ApiTags('Roles')
@Controller('roles')
export class RoleMasterController {

    constructor(
        private roleService: RoleMasterService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createRole')
    async createRole(@Body() roleDto:RoleDTO,isUpdate:boolean=false): Promise<RolesResponse> {
    try {
        return await this.roleService.createRole(roleDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(RolesResponse, error);
      }
    }
    @Post('/updateRole')
  async updateRole(@Body() roleDto: RoleDTO,@Req() request:Request): Promise<RolesResponse> {
    try {
      console.log(request);
      return await this.roleService.createRole(roleDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(RolesResponse, error);
    }
  }
  @Post('/getAllRoles')
  // @UseGuards(AuthGuard('jwt'))
  async getAllRoles(): Promise<AllRolesResponse> {

    try {
      return await this.roleService.getAllRoles();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllRolesResponse, error);
    }
  }
  @Post('/getAllActiveRoles')
  async getAllActiveRoles(@Req() request: Request): Promise<AllRolesResponse> {
      try {
          return await this.roleService.getAllActiveRoles();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllRolesResponse, error)
      }
  }
  @Post('/activateOrDeactivateRole')
  async activateOrDeactivateRole(@Body() Rolereq: RolesRequest): Promise<RolesResponse> {
      try {
          return await this.roleService.activateOrDeactivateRole(Rolereq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(RolesResponse, err);
      }
  }
}
